import { render, staticRenderFns } from "./file-upload.vue?vue&type=template&id=6c08aa4a&scoped=true"
import script from "./file-upload.vue?vue&type=script&lang=js"
export * from "./file-upload.vue?vue&type=script&lang=js"
import style0 from "./file-upload.vue?vue&type=style&index=0&id=6c08aa4a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c08aa4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c08aa4a')) {
      api.createRecord('6c08aa4a', component.options)
    } else {
      api.reload('6c08aa4a', component.options)
    }
    module.hot.accept("./file-upload.vue?vue&type=template&id=6c08aa4a&scoped=true", function () {
      api.rerender('6c08aa4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/ui/forms/file-upload/file-upload.vue"
export default component.exports